export default __webpack_public_path__ + "static/media/element_17.1dc601f1.webp";